import { createSelector } from 'reselect';
const getAccountsState = state => state.accounts;
const getPortalId = state => state.auth.portal.portal_id;
export const getAccounts = createSelector([getAccountsState], state => state.accounts);
export const getAccountsFetchStatus = createSelector([getAccountsState], state => state.accountsFetchStatus);
export const getAccountsPagination = createSelector([getAccountsState], state => state.accountsPagination);
export const getAccountName = createSelector([getAccounts, getPortalId], (accounts, portalId) => {
  const account = accounts.find(acc => acc.get('id') === portalId);
  return account ? account.accountName : null;
});